var EmailItemBase = require("./EmailItemBase");
var EmailItem = xClass("EmailItem", EmailItemBase, function () {
    return cc.CSLoader.createNode("cocos/mail_mail_common.csb");
})

EmailItem.prototype.ctor = function () {
    var self = this;
    EmailItemBase.prototype.ctor.call(self);
}

EmailItem.prototype.initData = function (data) {
    let self = this;
    EmailItemBase.prototype.initData.call(self, data);
    self.refreshUI(data);
}

EmailItem.prototype.refreshUI = function (data) {
    let self = this;
    //
    const hasDeletable = data.deletableFlag == 1;
    self.received.setVisible(hasDeletable);
    self.unreceive.setVisible(!hasDeletable);

    self.btn.setVisible(!hasDeletable)
    //
    self.mask.setVisible(hasDeletable);
    if (!data.expireTs) {
        self.title.y = 50;
    } else {
        self.title.y = 75.8;
    }
}

EmailItem.prototype.onClick = function () {
    let self = this;
    const deletableFlag = self.data.deletableFlag;
    EmailItemBase.prototype.getMailInfo.call(self, () => {
        self.EmailMgr.openDetailPanel(self.data, () => {
            self.EmailMgr.isBusy = false;
        }, () => {
            if (deletableFlag != self.data.deletableFlag) {
                self.EmailMgr.refreshMails();
            } else {
                self.initData(self.data);
            }
        });
    }, () => {
        self.EmailMgr.isBusy = false;
    })
}

EmailItem.prototype.onClickAccept = function () {
    let self = this;
    self.onClick();
}

module.exports = EmailItem;
